export default {"src":"/_next/static/media/vietNam.33be06ed.svg","height":23,"width":35};